import {initCircuitsPage} from "./circuits_page";
import {loadTrainingSnapshot} from "./training_snapshot";
import {loadTrainingCopy, initTrainingOverlay} from "./training_overlay";

const SNAPSHOT_URL = "/training/snapshots/circuits.json";
const COPY_URL = "/training/training_copy.json";

function forceDarkMode() {
    try {
        localStorage.setItem("theme", "dark");
    } catch (e) {
        // no-op
    }
    document.documentElement.setAttribute("data-bs-theme", "dark");
    document.body.classList.add("dark-mode");
}

function normalizeText(value) {
    return String(value || "").trim().toLowerCase();
}

function buildSites(circuits) {
    const sites = new Map();
    (circuits || []).forEach((circuit) => {
        if (!circuit.site_hash) {
            return;
        }
        const existing = sites.get(circuit.site_hash) || {
            site_hash: circuit.site_hash,
            site_name: circuit.site_name || "Unknown site",
            circuit_count: 0,
        };
        existing.circuit_count += 1;
        sites.set(circuit.site_hash, existing);
    });
    return Array.from(sites.values()).sort((a, b) => a.site_name.localeCompare(b.site_name));
}

function matchesSearch(circuit, term) {
    if (!term) {
        return true;
    }
    const searchFields = [
        circuit.circuit_name,
        circuit.circuit_id,
        ...(Array.isArray(circuit.search_terms) ? circuit.search_terms : []),
    ];
    return searchFields.some((field) => normalizeText(field).includes(term));
}

forceDarkMode();

(async () => {
    const snapshot = await loadTrainingSnapshot(SNAPSHOT_URL);
    const shapers = snapshot?.shapers || [];
    const circuitsByShaper = snapshot?.circuitsByShaper || {};

    initCircuitsPage({
        initialNodeId: shapers[0]?.node_id || "",
        loadShapers: async () => shapers,
        loadCircuits: async ({ nodeId, page, pageSize, search, siteHash }) => {
            const allCircuits = (circuitsByShaper[nodeId] || []).slice();
            const normalizedSearch = normalizeText(search);
            const sites = buildSites(allCircuits);

            let filtered = allCircuits.filter((circuit) => matchesSearch(circuit, normalizedSearch));
            if (siteHash) {
                filtered = filtered.filter((circuit) => String(circuit.site_hash || "") === String(siteHash));
            }

            filtered.sort((a, b) => normalizeText(a.circuit_name).localeCompare(normalizeText(b.circuit_name)));

            const total = filtered.length;
            const start = Math.max(0, (page - 1) * pageSize);
            const circuits = filtered.slice(start, start + pageSize);

            return {
                total,
                page,
                page_size: pageSize,
                sites,
                circuits,
            };
        },
    });

    const copy = await loadTrainingCopy(COPY_URL);
    initTrainingOverlay({ copy, pageKey: "circuits", dashboard: null });
})().catch((err) => {
    console.error(err);
    const list = document.getElementById("circuitsList");
    if (list) {
        list.innerHTML = "<div class='col-12'><div class='alert alert-danger'>Unable to load training circuits.</div></div>";
    }
});
